export default "__VITE_ASSET__a1b6b966__"